var _g, _path, _path2, _path3, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31331_29778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.464 158.087C212.168 119.904 199.933 70.3466 162.137 47.3972C124.34 24.4479 75.2954 36.7972 52.5918 74.9802L51.357 77.0568C28.6533 115.24 40.8883 164.797 78.6846 187.747C116.481 210.696 165.526 198.347 188.229 160.164L189.464 158.087Z",
    fill: "url(#paint0_linear_31331_29778)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.34 152.243C203.043 114.06 190.808 64.5028 153.012 41.5535C115.216 18.6041 66.171 30.9534 43.4673 69.1365L41.6442 72.2026C18.9405 110.386 31.1755 159.943 68.9718 182.892C106.768 205.842 155.813 193.492 178.517 155.309L180.34 152.243Z",
    fill: "url(#paint1_linear_31331_29778)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3405 77.4828L52.1636 74.4167C71.9823 41.0857 114.795 30.3056 147.788 50.3387C180.782 70.3719 191.462 113.632 171.643 146.963L169.82 150.029C150.002 183.36 107.189 194.14 74.1955 174.107C41.2021 154.074 30.5218 110.814 50.3405 77.4828ZM153.012 41.5535C190.808 64.5028 203.043 114.06 180.34 152.243L178.517 155.309C155.813 193.492 106.768 205.842 68.9718 182.892C31.1755 159.943 18.9405 110.386 41.6442 72.2026L43.4673 69.1365C66.171 30.9534 115.216 18.6041 153.012 41.5535Z",
    fill: "url(#paint2_linear_31331_29778)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3405 77.4828L52.1636 74.4167C71.9823 41.0857 114.795 30.3056 147.788 50.3387C180.782 70.3719 191.462 113.632 171.643 146.963L169.82 150.029C150.002 183.36 107.189 194.14 74.1955 174.107C41.2021 154.074 30.5218 110.814 50.3405 77.4828ZM153.012 41.5535C190.808 64.5028 203.043 114.06 180.34 152.243L178.517 155.309C155.813 193.492 106.768 205.842 68.9718 182.892C31.1755 159.943 18.9405 110.386 41.6442 72.2026L43.4673 69.1365C66.171 30.9534 115.216 18.6041 153.012 41.5535Z",
    fill: "url(#paint3_linear_31331_29778)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_31331_29778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.12 112.999C164.163 107.588 162.481 102.323 159.501 97.3934C156.198 92.2691 145.605 82.0762 133.34 74.6775C121.074 67.2788 107.136 62.6743 101.079 62.1523C95.3438 61.8249 89.9239 62.8061 85.6536 66.2705C81.3834 69.7349 79.7937 74.5925 78.5268 79.6449C74.7339 93.688 73.0114 108.309 73.4577 123.343C73.7969 130.483 74.6557 137.489 77.2975 144.451C78.8881 148.766 81.0337 152.522 85.1314 155.217C89.4259 157.584 93.7359 157.723 98.278 157.107C105.642 156.18 112.207 153.653 118.647 150.602C132.241 144.037 144.194 135.811 154.702 125.595C158.551 122.1 162.078 118.411 163.12 112.999Z",
    fill: "#00957B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9614 118.688C117.592 111.262 138.089 90.9639 142.89 81.1082C142.729 81.0109 142.406 80.8162 142.244 80.7188C141.374 79.9703 140.245 79.2889 139.213 78.4431C137.375 77.1105 135.438 75.9423 133.34 74.6767C132.695 74.2873 132.211 73.9952 131.565 73.6058C119.113 92.9404 90.0862 104.737 73.6221 109.124C73.3943 113.908 73.2649 118.528 73.4582 123.342C73.5489 124.292 73.5765 124.98 73.6671 125.929C96.7413 135.821 110.184 146.391 115.656 151.928C116.632 151.399 117.769 150.966 118.745 150.436C122.095 148.877 125.381 147.057 128.408 145.303C124.046 138.645 103.565 124.054 90.9614 118.688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31331_29778",
    x: 7.94727,
    y: 20.8584,
    width: 240.926,
    height: 243.427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31331_29778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31331_29778",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_31331_29778",
    x: 49.3643,
    y: 40.0928,
    width: 138.066,
    height: 143.325,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31331_29778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31331_29778",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.940104 0 0 0 0 0.940104 0 0 0 0 0.940104 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_31331_29778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31331_29778",
    x1: 202.958,
    y1: 71.7272,
    x2: 118.922,
    y2: 212.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#398A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758565,
    stopColor: "#072D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833789,
    stopColor: "#033C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91676,
    stopColor: "#04180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31331_29778",
    x1: 153.012,
    y1: 41.5535,
    x2: 67.6721,
    y2: 182.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06826C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831735,
    stopColor: "#095548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16413A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31331_29778",
    x1: 93.628,
    y1: 11.5719,
    x2: 96.6338,
    y2: 213.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.670529,
    stopColor: "#00957B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925805,
    stopColor: "#106254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153C37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31331_29778",
    x1: 219.26,
    y1: 51.0962,
    x2: 134.567,
    y2: 96.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.df0ab9ca.svg";
export { ForwardRef as ReactComponent };